import React, { useEffect, useState } from "react";
import { Pagination } from "react-bootstrap";
import { getAllTransactions } from "../../../../api/transaction";

const BuyBthTable = ({ selectedCoins }) => {
  console.log(selectedCoins, "selectedCoins");
  const rowsPerPage = 10;
  const [activePage, setActivePage] = useState(1);
  const [buyData, setBuyData] = useState([]);
  const [totalCount, setTotalCount] = useState(0); // total items count from server
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Helper to build filter param for coins
  const buildCoinFilter = () => {
    if (!selectedCoins.length) return null;
    // Assuming API supports filtering by coins as comma separated symbols
    console.log("RUNNER FOR API", selectedCoins);
    return selectedCoins.map((c) => c.value);
  };

  useEffect(() => {
    const fetchBuyTransactions = async () => {
      setLoading(true);
      setError(null);
      try {
        // Build filter param for coins if any selected
        const coinFilter = buildCoinFilter();
        console.log("COIN FILTER", coinFilter);

        // Call API with page, limit, type and coin filter
        const response = await getAllTransactions({
          page: activePage,
          limit: rowsPerPage,
          type: "buy",
          coinId: coinFilter, // you need to support this param in your backend
        });

        // Expect response to be { data: [], total: number }
        setBuyData(response.data || []);
        setTotalCount(response.total || 0);
      } catch (err) {
        setError("Failed to fetch buy transactions");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchBuyTransactions();
  }, [activePage, selectedCoins]);

  const totalPages = Math.ceil(totalCount / rowsPerPage);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setActivePage(page);
    }
  };

  const renderPagination = () => {
    if (totalPages <= 1) return null;

    const items = [];
    const visiblePages = 5;

    let startPage = Math.max(1, activePage - Math.floor(visiblePages / 2));
    let endPage = startPage + visiblePages - 1;

    if (endPage > totalPages) {
      endPage = totalPages;
      startPage = Math.max(1, endPage - visiblePages + 1);
    }

    if (startPage > 1) {
      items.push(
        <Pagination.Item key={1} onClick={() => handlePageChange(1)}>
          1
        </Pagination.Item>
      );
      if (startPage > 2) {
        items.push(
          <span key="start-ellipsis" className="px-2 text-primary">
            ...
          </span>
        );
      }
    }

    for (let number = startPage; number <= endPage; number++) {
      items.push(
        <Pagination.Item
          key={number}
          active={number === activePage}
          onClick={() => handlePageChange(number)}
        >
          {number}
        </Pagination.Item>
      );
    }

    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        items.push(
          <span key="end-ellipsis" className="px-2 text-primary">
            ...
          </span>
        );
      }
      items.push(
        <Pagination.Item
          key={totalPages}
          onClick={() => handlePageChange(totalPages)}
        >
          {totalPages}
        </Pagination.Item>
      );
    }

    return (
      <Pagination className="mt-4 pagination-gutter pagination-primary no-bg">
        <li className="page-item page-indicator">
          <a
            href="#!"
            className="page-link"
            onClick={(e) => {
              e.preventDefault();
              handlePageChange(activePage - 1);
            }}
            aria-disabled={activePage === 1}
          >
            <i className="la la-angle-left" />
          </a>
        </li>
        {items}
        <li className="page-item page-indicator">
          <a
            href="#!"
            className="page-link"
            onClick={(e) => {
              e.preventDefault();
              handlePageChange(activePage + 1);
            }}
            aria-disabled={activePage === totalPages}
          >
            <i className="la la-angle-right" />
          </a>
        </li>
      </Pagination>
    );
  };

  if (loading) return <p>Loading buy transactions...</p>;
  if (error) return <p className="text-danger">{error}</p>;

  return (
    <div className="table-responsive dataTablehistory">
      <div id="buybthdata_wrapper" className="dataTables_wrapper no-footer">
        <table
          className="table dataTable shadow-hover display"
          style={{ minWidth: "845px" }}
        >
          <thead>
            <tr>
              <th>Date</th>
              <th>Pair</th>
              <th>Quantity</th>
              <th>Side</th>
              <th>Price</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            {buyData.length > 0 ? (
              buyData.map((item, index) => {
                const quantity = Number(item.quantity);
                const price = Number(item?.price);
                const total =
                  quantity && price ? (quantity * price).toFixed(4) : "0.0000";

                const date = item.createdAt
                  ? new Date(item.createdAt).toLocaleString()
                  : "N/A";

                const pair = item?.coin?.symbol || "N/A";

                return (
                  <tr key={item.id || index}>
                    <td>{date}</td>
                    <td>{pair}</td>
                    <td>{item.quantity}</td>
                    <td>Buy</td>
                    <td>{item.price}</td>
                    <td>{total}</td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={5} className="text-center">
                  No buy orders found
                </td>
              </tr>
            )}
          </tbody>
        </table>
        <div className="d-flex justify-content-center w-100 mt-3 mb-3">
          {renderPagination()}
        </div>
      </div>
    </div>
  );
};

export default BuyBthTable;
